/* eslint-disable */

var ExtraPost = {
  token: null,
  courierCarriers: [],
  pickupCarriers: [],
  pickupRates: [],
  carriers: [],
  from: "",
  to: "",
  fixed_rate: null,
  target: null,
  document: null,
  courier: true,
  pickup: true,
  init(params) {
    console.log(params);
    this.token = params["token"];
    this.from = params["from"];
    this.weight = params["weight"];
    this.fixed_rate = params["fixed_rate"] || null;
    this.pickup = params["pickup"] !== false;
    this.courier = params["courier"] !== false;

    this.window = params["window"] || window;
    this.document = params["document"] || document;
    this.target =
      params["target"] || this.document.getElementById(params["target_id"]);

    this.carriers = params["carriers"] || [];
    this.exceptions = params["exceptions"] || [];

    if (this.weight > 0) {
      this.addStyle();
      this.createHTML();
      this.ops = this.myOPS();
      this.setCurrentPostcode(this.ops.index);
      this.updateRates();
      this.loadCity();
      console.log(this.ops);
      if (this.pickup) this.mountMap();
    } else if (this.fixed_rate !== null) {
      this.addStyle();
      this.createCitySelector();
      if (localStorage.getItem("extrapost_location_name")) {
        this.setCurrentCity(localStorage.getItem("extrapost_location_name"));
        this.to = localStorage.getItem("extrapost_location_postcode");
        this.showTerm(localStorage.getItem("extrapost_location_term"));
      } else {
        this.loadCityAndTerm();
      }
    }
  },
  addStyle() {
    var style = this.document.createElement("style");
    style.innerHTML =
      ".extrapost-delivery { margin-top: 1em; margin-bottom: 2em; }" +
      ".extrapost-delivery p { margin-bottom: 0.5em !important; }" +
      ".extrapost-delivery p img { display: inline; margin-right: 0.2em; vertical-align: middle; }" +
      ".extrapost-delivery a { font-weight: 500; text-decoration: none; border-bottom: 1px dashed; }" +
      ".extrapost-delivery ul { padding-left: 0em; margin-bottom: 0.7em; }" +
      ".extrapost-modal {  display: none;  position: fixed;  z-index: 1024;   padding-top: 100px; left: 0; top: 0; width: 100%;  height: 100%; overflow: auto; background-color: rgb(0,0,0); background-color: rgba(0,0,0,0.4); }" +
      ".extrapost-modal-content {  background-color: #fefefe;  margin: auto;  padding: 11px;  border: 1px solid #888; overflow: hidden; }" +
      "@media (min-width: 769px) { #extrapost-map { width: 80%; } #extrapost-city { width: 50%; } .extrapost-modal-content { height: 80%; } }" +
      "#extrapost-city input {border: solid 1px #888; border-radius: 7px; font-size: 18pt; padding: 3pt 5pt; width: 100%; }" +
      "#extrapost-city ul { margin-left: 0; padding-left: 0; margin-top: 10px; list-style: none !important; }" +
      "#extrapost-city li { list-style: none !important; padding-bottom: 4pt; padding-left: 7pt; cursor: pointer; }" +
      "#extrapost-city li:before { content: none !important; }" +
      "#extrapost-city li:hover { background-color: #efefef; }" +
      "#extrapost-city .city {font-size: 12pt; font-weight: 400; color: #00bbff; margin-bottom: -3pt;}" +
      "#extrapost-city .region { font-size: 10pt; }" +
      "@media (max-width: 768px) { .extrapost-modal { padding-top: 0; } #extrapost-map, #extrapost-city { width: 100% !important; height: 100%; } #extrapost-map { padding: 0; } }" +
      ".extrapost-close {  color: #aaaaaa;  float: right;  font-size: 28px;  font-weight: bold; }" +
      ".extrapost-close:hover, .extrapost-close:focus {  color: #000;  text-decoration: none;  cursor: pointer; }" +
      ".city-modal-close { font-size: 180%; float: right; padding: 0 6px; line-height: 3px; height: 1em; border: none; cursor: pointer;  position: relative; top: -5px; }" +
      '#extrapost-city header { padding-left: 30px; height: 1.5em; padding-top: 5px; margin-top: 3px; margin-bottom: 16px;  background: url("https://my.extrapost.ru/img/map_marker.svg") left no-repeat; }' +
      "#extrapost-city header span { position: relative; top: -3px; font-weight: 400; font-size: 1.4em; line-height: 1.1em; }";

    // Get the first script tag
    var ref = this.document.querySelector("script");

    // Insert our new styles before the first script tag
    ref.parentNode.insertBefore(style, ref);

    this.target.setAttribute("class", "extrapost-delivery");
  },
  createHTML() {
    var self = this;

    this.createCitySelector();

    if (this.courier) {
      var courier = this.document.createElement("div");
      var courierTitle = this.document
        .createElement("p")
        .appendChild(this.document.createTextNode("Курьером:"));
      this.courierList = this.document.createElement("ul");
      courier.appendChild(courierTitle);
      courier.appendChild(this.courierList);
      this.target.appendChild(courier);
    }

    if (this.pickup) {
      var pickup = this.document.createElement("div");
      console.log(pickup);
      var pickupTitle = this.document
        .createElement("p")
        .appendChild(this.document.createTextNode("Самовывоз:"));
      this.pickupList = this.document.createElement("ul");
      pickup.appendChild(pickupTitle);
      pickup.appendChild(this.pickupList);
      this.target.appendChild(pickup);

      var parcelshops = this.document.createElement("p");
      var parcelshopsHref = this.document.createElement("a");

      var mapImg = this.document.createElement("img");
      mapImg.setAttribute("src", "https://extrapost.ru/img/map.svg");
      mapImg.setAttribute("style", "height: 1.3em !important;");
      parcelshops.appendChild(mapImg);

      parcelshopsHref.appendChild(
        this.document.createTextNode("Карта пунктов выдачи")
      );
      parcelshopsHref.setAttribute("href", "javascript:void(0)");
      parcelshopsHref.addEventListener("click", () => self.showParcelshops());
      parcelshops.appendChild(parcelshopsHref);

      // Map modal
      this.mapModal = this.document.createElement("div");
      this.mapModal.setAttribute("class", "extrapost-modal");

      var mapModalContent = this.document.createElement("div");
      mapModalContent.setAttribute("class", "extrapost-modal-content");
      mapModalContent.setAttribute("id", "extrapost-map");
      this.mapModal.appendChild(mapModalContent);

      this.target.appendChild(parcelshops);
      this.target.appendChild(this.mapModal);
    }

    this.createModalCloseHandler();
  },
  createModalCloseHandler() {
    var self = this;
    window.onclick = function(event) {
      if (event.target === self.mapModal) self.closeMap();
      else if (event.target === self.cityModal) self.closeCityModal();
    };
  },
  createCitySelector() {
    var self = this;

    this.citySelector = this.document.createElement("p");
    this.citySelector.appendChild(this.document.createTextNode("Доставим в "));

    var locationImg = this.document.createElement("img");
    locationImg.setAttribute("src", "https://extrapost.ru/img/location.svg");
    locationImg.setAttribute("style", "width: 0.7em;");
    this.citySelector.appendChild(locationImg);

    this.cityName = this.document.createElement("a");
    this.cityName.setAttribute("href", "javascript:void(0)");
    this.cityName.addEventListener("click", () => self.showCitySelector());
    this.citySelector.append(this.cityName);

    this.termSpan = this.document.createElement("span");
    this.termSpan.innerHTML = " " + this.formatFixedRate();
    this.citySelector.append(this.termSpan);

    this.createCityModalHTML();

    this.target.appendChild(this.citySelector);
  },
  createCityModalHTML() {
    var self = this;

    // City modal
    this.cityModal = this.document.createElement("div");
    this.cityModal.setAttribute("class", "extrapost-modal");

    var cityModalContent = this.document.createElement("div");
    cityModalContent.setAttribute("class", "extrapost-modal-content");
    cityModalContent.setAttribute("id", "extrapost-city");
    this.cityModal.appendChild(cityModalContent);

    var cityModalHeader = this.document.createElement("header");
    this.modalCityName = this.document.createElement("span");
    cityModalHeader.appendChild(this.modalCityName);

    var cityModalCloseButton = this.document.createElement("button");
    cityModalCloseButton.className = "city-modal-close";
    cityModalCloseButton.innerHTML = "&times;";
    cityModalCloseButton.addEventListener("click", (event) => {
      self.closeCityModal();
      event.stopPropagation();
      return false;
    });

    cityModalHeader.appendChild(cityModalCloseButton);

    this.cityInput = this.document.createElement("input");
    this.cityInput.addEventListener("keyup", (event) => self.hintCity(event));

    this.cityList = this.document.createElement("ul");
    this.fillCityList([
      ["Москва", "", "", "", ""],
      ["Санкт-Петербург", "", "", "", ""],
      ["Новосибирская область", "", "Новосибирск", "", ""],
      ["Свердловская область", "", "Екатеринбург", "", ""],
      ["Нижегородская область", "", "Нижний Новгород", "", ""],
      ["Татарстан республика", "", "Казань", "", ""],
      ["Самарская область", "", "Самара", "", ""],
      ["Омская область", "", "Омск", "", ""],
      ["Челябинская область", "", "Челябинск", "", ""],
      ["Ростовская область", "", "Ростов-на-Дону", "", ""],
      ["Башкортостан республика", "", "Уфа", "", ""],
      ["Волгоградская область", "", "Волгоград", "", ""],
      ["Красноярский край", "", "Красноярск", "", ""],
      ["Пермский край", "", "Пермь", "", ""],
      ["Воронежская область", "", "Воронеж", "", ""],
      ["Саратовская область", "", "Саратов", "", ""],
      ["Краснодарский край", "", "Краснодар", "", ""],
      ["Самарская область", "", "Тольятти", "", ""],
      ["Удмуртская республика", "", "Ижевск", "", ""],
      ["Алтайский край", "", "Барнаул", "", ""],
      ["Ульяновская область", "", "Ульяновск", "", ""],
      ["Тюменская область", "", "Тюмень", "", ""],
      ["Иркутская область", "", "Иркутск", "", ""],
      ["Приморский край", "", "Владивосток", "", ""],
      ["Ярославская область", "", "Ярославль", "", ""],
    ]);

    cityModalContent.appendChild(cityModalHeader);
    cityModalContent.appendChild(this.cityInput);
    cityModalContent.appendChild(this.cityList);
    this.cityHinterXHR = new XMLHttpRequest();

    this.target.appendChild(this.cityModal);

    this.createModalCloseHandler();
  },
  closeMap() {
    this.mapModal.style.display = "none";
  },
  closeCityModal() {
    this.cityModal.style.display = "none";
  },
  mountMap() {
    var self = this;
    var script = this.document.createElement("script"); // Make a script DOM node
    script.type = "text/javascript";
    script.onload = () => {
      self.window.ymaps.ready(function() {
        self.map = new self.window.ymaps.Map("extrapost-map", {
          center: self.myCoords(),
          zoom: 12,
          controls: ["geolocationControl", "zoomControl"],
        });
        self.mapObjectManager = new self.window.ymaps.ObjectManager({
          // Чтобы метки начали кластеризоваться, выставляем опцию.
          clusterize: false,
          // ObjectManager принимает те же опции, что и кластеризатор.
          gridSize: 18,
          clusterDisableClickZoom: true,
        });
        // objectManager.objects.options.set('preset', 'islands#greenDotIcon')
        // objectManager.clusters.options.set('preset', 'islands#greenClusterIcons')
        self.map.geoObjects.add(self.mapObjectManager);
        self.mapObjectManager.objects.events.add(["click"], (e) => {
          self.onParcelshopClick(e);
        });

        var carrierFilterItems = self.pickupRates.map(
          (carrier) =>
            new self.window.ymaps.control.ListBoxItem({
              data: { content: carrier.title, carrier: carrier.code },
              state: { selected: true },
            })
        );
        var carrierFilter = new self.window.ymaps.control.ListBox({
          data: {
            content: "Фильтр перевозчиков",
          },
          items: carrierFilterItems,
          state: {
            filters: carrierFilterItems.reduce(function(filters, filter) {
              filters[filter.data.get("carrier")] = filter.isSelected();
              return filters;
            }, {}),
          },
        });
        self.map.controls.add(carrierFilter);

        // Adding tracking to the indicator to check if a list item is selected.
        carrierFilter.events.add(["select", "deselect"], function(e) {
          var listBoxItem = e.get("target");
          var filters = self.window.ymaps.util.extend(
            {},
            carrierFilter.state.get("filters")
          );
          filters[listBoxItem.data.get("carrier")] = listBoxItem.isSelected();
          carrierFilter.state.set("filters", filters);
        });

        // Tracking changes to the control.ListBox.state field.
        var filterMonitor = new self.window.ymaps.Monitor(carrierFilter.state);

        filterMonitor.add("filters", function(filters) {
          // Applying the filter to ObjectManager.
          self.mapObjectManager.setFilter((obj) => {
            return filters[obj.properties.carrier];
          });
        });

        var closeButton = new self.window.ymaps.control.Button({
          data: {
            content:
              "<span style='font-size: 28px; position: relative; left: -6px;'>&times;</span>",
            title: "Закрыть",
          },
          options: { maxWidth: 30, float: "right" },
        });
        closeButton.events.add("click", function(event) {
          self.closeMap();
        });
        console.log(closeButton);
        self.map.controls.add(closeButton);

        self.updateMap({ to: self.ops.index });
      });
    };
    script.src = "https://api-maps.yandex.ru/2.1/?lang=ru_RU";
    this.document.head.appendChild(script);
  },
  updateMap(opts) {
    var xhr = this.createXHR(`/v1/geo/parcelshops/${this.to}`);
    var self = this;
    var lastIndex = 0;
    xhr.onprogress = function() {
      var currIndex = xhr.responseText.length;
      if (lastIndex === currIndex) return;

      var newChunk = xhr.responseText.substring(lastIndex, currIndex);

      // Check if chunk is complete, not cut in the middle
      if (newChunk.substring(newChunk.length - 3) === "<|>") {
        var shopsLists = newChunk
          .split("<|>")
          .filter((sl) => sl !== "")
          .map((sl) => JSON.parse(sl));

        lastIndex = currIndex;

        shopsLists.forEach((sl) =>
          self.mapObjectManager.add({
            type: "FeatureCollection",
            features: sl,
          })
        );
      }
    };
    xhr.send();
    if (opts.centerMap) {
      var newCenter = this.coordsFromPostcode(this.to);
      if (newCenter[0] !== null) {
        this.map.setCenter(newCenter, 13);
      }
    }
    this.mapObjectManager.removeAll();
  },
  onParcelshopClick(e) {
    var id = e.get("objectId");
    var shop = this.mapObjectManager.objects.getById(id);
    console.log(shop);
  },
  clearRates() {
    this.courierCarriers = [];
    this.pickupCarriers = [];
    this.pickupRates = [];

    if (this.pickupList) this.pickupList.innerHTML = "";
    if (this.courierList) this.courierList.innerHTML = "";
  },
  updateRates(opts) {
    this.clearRates();
    console.log(this);

    var lastIndex = 0;
    var xhr = this.createXHR(
      `/v1/rates?from=${this.from}&to=${this.to}&weight=${
        this.weight
      }&carriers=${this.carriers.join(";")}&locale=ru`
    );
    var self = this;
    xhr.onprogress = function() {
      var currIndex = xhr.responseText.length;
      if (lastIndex === currIndex) return;
      var rts = xhr.responseText
        .substring(lastIndex, currIndex)
        .replace(/<\|>$/gm, "")
        .split("<|>")
        .map((r) => JSON.parse(r));
      console.log(rts);
      lastIndex = currIndex;
      if (self.target) {
        rts.map((rt) => {
          if (rt.length > 0) {
            rt.forEach((r) => {
              var li = self.document.createElement("li");
              var text = self.document.createTextNode(
                r["carrier_title"] +
                  " — " +
                  r["rate"] +
                  " RUB, " +
                  r["delivery_days"] +
                  " дня"
              );
              li.appendChild(text);
              if (
                self.courier &&
                r["type"] === "courier" &&
                r["rate"] !== null &&
                !self.courierCarriers.includes(r["carrier"])
              ) {
                self.courierList.appendChild(li);
                self.courierCarriers.push(r["carrier"]);
              } else if (
                self.pickup &&
                r["type"] === "pickup" &&
                r["rate"] !== null &&
                !self.pickupCarriers.includes(r["carrier"])
              ) {
                self.pickupList.appendChild(li);
                self.pickupCarriers.push(r["carrier"]);
                self.pickupRates.push({
                  code: r["carrier"],
                  title: text.textContent,
                });
              }
            });
          }
        });
      }
    };
    xhr.send();
  },
  showParcelshops() {
    this.mapModal.style.display = "block";
  },
  showCitySelector() {
    this.cityModal.style.display = "block";
    this.cityInput.focus();
  },
  changeCity(el) {
    this.closeCityModal();

    var city_1 = el.getAttribute("data-city_1");
    var city = el.getAttribute("data-city");
    var area = el.getAttribute("data-area");
    var region = el.getAttribute("data-region");
    var autonom = el.getAttribute("data-autonom");

    var cityName = region;
    if (city_1 !== "") cityName = city_1;
    else if (city !== "") cityName = city;

    this.setCurrentCity(cityName);

    this.setCurrentPostcode(
      this.postcodeFromCity(region, area, city, city_1, autonom)["index"]
    );

    if (this.fixed_rate !== null) this.updateTerm();
    else this.updateRates();

    if (this.mapModal) this.updateMap({ centerMap: true });
  },
  hintCity(event) {
    // retireve the input element
    var input = event.target;

    // minimum number of characters before we start to generate suggestions
    var min_characters = 2;

    if (input.value.length < min_characters) {
    } else {
      // abort any pending requests
      this.cityHinterXHR.abort();

      var self = this;
      this.cityHinterXHR.onreadystatechange = function() {
        if (this.readyState == 4 && this.status === 200) {
          // We're expecting a json response so we convert it to an object
          var response = JSON.parse(this.responseText);

          self.fillCityList(response);
        }
      };

      this.cityHinterXHR.open(
        "GET",
        this.server() + "/v1/geo/cityhint/" + input.value,
        true
      );
      this.cityHinterXHR.setRequestHeader(
        "Authorization",
        "Basic " + this.token
      );
      this.cityHinterXHR.send();
    }
  },
  fillCityList(cities) {
    // clear any previously loaded options in the datalist
    this.cityList.innerHTML = "";

    var self = this;
    cities.forEach(function(item) {
      var region = item[0];
      var area = item[1];
      var city = item[2];
      var city_1 = item[3];
      var autonom = item[4];

      var li = self.document.createElement("li");
      li.setAttribute("data-region", region);
      li.setAttribute("data-area", area);
      li.setAttribute("data-city", city);
      li.setAttribute("data-city_1", city_1);
      li.setAttribute("data-autonom", autonom);

      li.addEventListener("click", (e) => self.changeCity(li));
      var cityDiv = self.document.createElement("div");
      cityDiv.className = "city";

      if (city_1 !== "") cityDiv.innerText = city_1;
      else if (city !== "") cityDiv.innerText = city;
      else cityDiv.innerText = region;

      var regionDiv = self.document.createElement("div");
      regionDiv.className = "region";
      var regionParts = [region, area];
      if (region === "") regionParts[0] = autonom;
      if (city_1 !== "") regionParts.push(city);
      regionDiv.innerText = regionParts.filter((s) => s !== "").join(", ");

      li.appendChild(cityDiv);
      li.appendChild(regionDiv);

      // attach the option to the datalist element
      self.cityList.appendChild(li);
    });
  },
  createXHR(url) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", this.server() + url);
    xhr.setRequestHeader("Authorization", "Basic " + this.token);
    return xhr;
  },
  get(url) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", this.server() + `/v1/${url}`, false);
    xhr.setRequestHeader("Authorization", "Basic " + this.token);
    xhr.send(null);
    return JSON.parse(xhr.responseText);
  },
  server() {
    return "https://api.extrapost.ru:5433";
  },
  coordsFromPostcode(index) {
    return this.get(`geo/ops/${index}/coords`);
  },
  postcodeFromCoords(coords) {
    return this.get(`geo/ops?coords=${coords}`);
  },
  postcodeFromCity(region, area, city, city_1, autonom) {
    return this.get(
      `geo/ops?region=${region}&area=${area}&city=${city}&city_1=${city_1}&autonom=${autonom}`
    );
  },
  myOPS() {
    return this.get("geo/my/ops");
  },
  myCoords() {
    return this.get("geo/my/coords");
  },
  loadCity() {
    var xhr = this.createXHR("/v1/geo/my/city");
    var self = this;
    xhr.onload = function() {
      if (xhr.responseText !== "") {
        self.setCurrentCity(xhr.responseText);
        if (self.exceptions.hasOwnProperty(xhr.responseText)) {
          self.termSpan.innerText =
            " " + self.exceptions[xhr.responseText].call();
        }
      } else {
        self.citySelector.innerText =
          "Доставим " + self.formatFixedRate() + ".";
        self.cityName.innerText = "Неизвестный";
      }
    };
    xhr.send();
  },
  updateTerm() {
    var term = this.get(`term?from=${this.from}&to=${this.to}`);
    if (term.max_days && term.max_days > 0) {
      var averageDays = Math.floor((term.min_days + term.max_days) / 2);
      this.showTerm(averageDays);
      localStorage.setItem("extrapost_location_term", averageDays);
    }
  },
  loadCityAndTerm() {
    this.loadCity();
    this.updateTerm();
  },
  formatFixedRate() {
    if (this.fixed_rate !== null) {
      return this.fixed_rate > 0
        ? "за " + this.fixed_rate + " руб."
        : "бесплатно";
    } else {
      return "";
    }
  },
  days(days) {
    if (days === 1) return "день";
    else if (days > 1 && days < 5) return "дня";
    else if (days === 0 || (days >= 5 && days <= 20)) return "дней";
    else return this.days(days % 10);
  },
  incline(city) {
    return city
      .replace(/ая$/, "ую")
      .replace(/а$/, "у")
      .replace(/я$/, "ю");
  },
  setCurrentCity(city) {
    this.cityName.innerText = this.incline(city);
    this.modalCityName.innerText = city;
    localStorage.setItem("extrapost_location_name", city);
  },
  setCurrentPostcode(postcode) {
    this.to = postcode;
    localStorage.setItem("extrapost_location_postcode", postcode);
  },
  showTerm(days) {
    this.termSpan.innerHTML = " " + this.formatFixedRate();
    if (days <= 7) {
      this.termSpan.innerHTML += " за " + days + " " + this.days(days) + ".";
    }
  },
};

window.ExtraPost = ExtraPost;
